var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mainPage"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"messageBox"},[_vm._v(" system: "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }